import "../Menu.css";
import Footer from "./footer";
import Navbar from "./navbar";

const Agripreneurs = () => {
	return (
		<>
			<Navbar />

			<div className="agripreneur-container">
				<div className="agripreneur-title row">
					<div className="agripreneur-t1"> Empowering Women Agripreneurs: </div>
					{/* <div style={{ padding: "0" }}>
            {" "}
            Unlocking Business Opportunities for women Agripreneurs in Rural
            Crop Production Centers
          </div> */}
				</div>
				<div className="row agripreneur-images-matter">
					<div className="col-sm-12 col-md-12 col-lg-8 ">
						<div classname="row " style={{ paddingBottom: "20px" }}>
							<div
								className="col-sm-12 col-md-8 agripreneur-matter-container"
								style={{ paddingBottom: "10px", width: "100%" }}>
								<div className="elementor-widget-container">
									<p>
										<h4>
											Unlocking Business Opportunities for women Agripreneurs in
											Rural Crop Production Centers:
										</h4>
									</p>
									<p
										className="elementor-icon-list-text"
										style={{ fontWeight: "lighter" }}>
										Women in rural crop production centers can be empowered
										through training on India Good Agricultural Practices
										(IndG.A.P), enabling them to enhance their livelihoods by:
									</p>
									<ul>
										<li>
											<div className="list-item">
												<div className="elementor-icon-list-icon">
													<svg
														aria-hidden="true"
														className="e-font-icon-svg e-fas-leaf"
														viewBox="0 0 576 512"
														xmlns="http://www.w3.org/2000/svg">
														<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
													</svg>
												</div>
												<span className="elementor-icon-list-text">
													<p style={{ fontWeight: "lighter" }}>
														Identifying and supplying quality farm inputs
														(seeds, micronutrients, plant protection products,
														sprayers, and small farm tools)
													</p>
												</span>
											</div>
										</li>
										<li>
											<div className="list-item">
												<span className="elementor-icon-list-icon">
													<svg
														aria-hidden="true"
														className="e-font-icon-svg e-fas-leaf"
														viewBox="0 0 576 512"
														xmlns="http://www.w3.org/2000/svg">
														<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
													</svg>{" "}
												</span>
												<span className="elementor-icon-list-text">
													<p style={{ fontWeight: "lighter" }}>
														{" "}
														Preparing organic inputs locally
													</p>
												</span>
											</div>
										</li>
										<li>
											<div className="list-item">
												<span className="elementor-icon-list-icon">
													<svg
														aria-hidden="true"
														className="e-font-icon-svg e-fas-leaf"
														viewBox="0 0 576 512"
														xmlns="http://www.w3.org/2000/svg">
														<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
													</svg>{" "}
												</span>
												<span className="elementor-icon-list-text">
													<p style={{ fontWeight: "lighter" }}>
														Collecting soil and water samples for testing
													</p>{" "}
												</span>
											</div>
										</li>
										<li>
											<div className="list-item">
												<span className="elementor-icon-list-icon">
													<svg
														aria-hidden="true"
														className="e-font-icon-svg e-fas-leaf"
														viewBox="0 0 576 512"
														xmlns="http://www.w3.org/2000/svg">
														<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
													</svg>{" "}
												</span>
												<span className="elementor-icon-list-text">
													<p style={{ fontWeight: "lighter" }}>
														Supporting basic maintenance of small agricultural
														machinery
													</p>{" "}
												</span>
											</div>
										</li>
									</ul>
									<p
										className="elementor-icon-list-text"
										style={{ fontWeight: "lighter" }}>
										By building their capacity in the IndG.A.P Certification
										Scheme — developed by the Quality Council of India (QCI)
										under the Ministry of Commerce & Industry , Govt of India
										,women can play a critical role in promoting sustainable,
										quality-focused farming at the grassroots level.
									</p>
								</div>
							</div>
						</div>
						<div classname="row " style={{ paddingBottom: "20px" }}>
							<div
								className="col-sm-12 col-md-4 agripreneur-matter-container"
								style={{ paddingBottom: "10px", width: "100%" }}>
								<div className="elementor-widget-container">
									<p>
										<strong>Course Overview:</strong>
									</p>
									<p
										className="elementor-icon-list-text"
										style={{ fontWeight: "lighter" }}>
										This program equips women to become Agripreneurs and Brand
										Ambassadors for IndG.A.P, bridging the gap between quality
										farm inputs, good agricultural practices, and rural service
										delivery. This initiative drives rural economic empowerment
										while enhancing farm productivity, food safety, and
										environmental stewardship.
									</p>
								</div>
							</div>
						</div>

						<div classname="row">
							<div
								className="col agripreneur-matter-container"
								style={{ width: "100%" }}>
								<div className="elementor-widget-container">
									<p>
										<strong>Why Sponsor This Program:</strong>
									</p>

									<ul>
										<li>
											<div className="list-item">
												<div className="elementor-icon-list-icon">
													<svg
														aria-hidden="true"
														className="e-font-icon-svg e-fas-leaf"
														viewBox="0 0 576 512"
														xmlns="http://www.w3.org/2000/svg">
														<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
													</svg>
												</div>
												<span className="elementor-icon-list-text">
													<p style={{ fontWeight: "lighter" }}>
														Strengthening the role of women in farming
														communities by enhancing their skills, income, and
														leadership in rural agri-business ecosystems."
													</p>
												</span>
											</div>
										</li>
										<li>
											<div className="list-item">
												<span className="elementor-icon-list-icon">
													<svg
														aria-hidden="true"
														className="e-font-icon-svg e-fas-leaf"
														viewBox="0 0 576 512"
														xmlns="http://www.w3.org/2000/svg">
														<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
													</svg>{" "}
												</span>
												<span className="elementor-icon-list-text">
													<p style={{ fontWeight: "lighter" }}>
														{" "}
														Contribute to sustainable agriculture, women's
														empowerment, and rural economic development.
													</p>
												</span>
											</div>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<div className="col-sm-12 col-lg-4 agripreneur-images-container">
						<div className="row image-container">
							<img src="../images/agripreneurs1.jpg" alt="" className="image" />
						</div>
						<div className="row image-container">
							<img src="../images/agripreneurs2.jpg" alt="" className="image" />
						</div>
						<div className="row image-container">
							<img src="../images/agripreneurs3.jpg" alt="" className="image" />
						</div>
					</div>
				</div>
				{/* <div className="row agripreneur-images-matter-2">
          <div className="col-sm-12 col-md-6 agripreneur-matter-container-2">
            <div style={{ fontSize: "20px", padding: "20px 0 10px 0" }}>
              <strong>Key Objectives</strong>
              <br />
            </div>
            <ul >
              <li >
                <div className="list-item">
                  <div className="elementor-icon-list-icon">
                    <svg
                      aria-hidden="true"
                      className="e-font-icon-svg e-fas-leaf"
                      viewBox="0 0 576 512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
                    </svg>
                  </div>
                  <span className="elementor-icon-list-text">
                    {" "}
                    <p style={{ fontWeight: "lighter" }}>
                      Equip women Agripreneurs in rural areas to become Brand
                      Ambassadors for the IndG.A.P scheme, enhancing their
                      livelihoods and influence in local agriculture.
                    </p>
                  </span>
                </div>
              </li>
              <li >
                <div className="list-item">
                  <span className="elementor-icon-list-icon">
                    <svg
                      aria-hidden="true"
                      className="e-font-icon-svg e-fas-leaf"
                      viewBox="0 0 576 512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
                    </svg>{" "}
                  </span>
                  <span className="elementor-icon-list-text">
                    <p style={{ fontWeight: "lighter" }}>
                      {" "}
                      Expand the presence of skilled women entrepreneurs
                      actively contributing to agricultural development in rural
                      communities.
                    </p>
                  </span>
                </div>
              </li>
              <li >
                <div className="list-item">
                  <span className="elementor-icon-list-icon">
                    <svg
                      aria-hidden="true"
                      className="e-font-icon-svg e-fas-leaf"
                      viewBox="0 0 576 512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
                    </svg>{" "}
                  </span>
                  <span className="elementor-icon-list-text">
                    <p style={{ fontWeight: "lighter" }}>
                      Strengthen the financial sustainability of women
                      entrepreneurs and farmers by integrating sustainable,
                      profitable practices.{" "}
                    </p>{" "}
                  </span>
                </div>
              </li>

              <li >
                <div className="list-item">
                  <span className="elementor-icon-list-icon">
                    <svg
                      aria-hidden="true"
                      className="e-font-icon-svg e-fas-leaf"
                      viewBox="0 0 576 512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
                    </svg>{" "}
                  </span>
                  <span className="elementor-icon-list-text">
                    <p style={{ fontWeight: "lighter" }}>
                      Empower women Agripreneurs to lead farmers in reducing
                      carbon footprints through adherence to on-farm food safety
                      and sustainability standards.{" "}
                    </p>{" "}
                  </span>
                </div>
              </li>
            </ul>
          </div>
          <div className="col-sm-12 col md-6 agripreneur-matter-container-2">
            <div
              style={{
                fontSize: "20px",
                padding: "10px 0 10px 0",
                marginTop: "20px",
              }}
            >
              <strong>
                Impact Creation for Women Agripreneurs in Supporting the
                IndG.A.P Scheme
              </strong>
              <br />
            </div>
            <ul >
              <li >
                <div className="list-item">
                  <div className="elementor-icon-list-icon">
                    <svg
                      aria-hidden="true"
                      className="e-font-icon-svg e-fas-leaf"
                      viewBox="0 0 576 512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
                    </svg>
                  </div>
                  <span className="elementor-icon-list-text">
                    <strong>Increased Income and Livelihoods</strong>
                    <br />{" "}
                    <p style={{ fontWeight: "lighter" }}>
                      Women Agripreneurs will generate new income by guiding
                      farmers through certification and offering support
                      services, benefiting the rural economy.
                    </p>
                  </span>
                </div>
              </li>
              <li >
                <div className="list-item">
                  <span className="elementor-icon-list-icon">
                    <svg
                      aria-hidden="true"
                      className="e-font-icon-svg e-fas-leaf"
                      viewBox="0 0 576 512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
                    </svg>{" "}
                  </span>
                  <span className="elementor-icon-list-text">
                    <strong>Skilled Agricultural Workforce</strong>
                    <br />
                    <p style={{ fontWeight: "lighter" }}>
                      {" "}
                      Women will educate farmers, creating a digitally skilled
                      workforce in rural agriculture
                    </p>
                  </span>
                </div>
              </li>
              <li >
                <div className="list-item">
                  <span className="elementor-icon-list-icon">
                    <svg
                      aria-hidden="true"
                      className="e-font-icon-svg e-fas-leaf"
                      viewBox="0 0 576 512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
                    </svg>{" "}
                  </span>
                  <span className="elementor-icon-list-text">
                    <b>Financial and Food Safety Sustainability</b>
                    <br />
                    <p style={{ fontWeight: "lighter" }}>
                      Local farmers, guided by Agripreneurs, will adopt
                      cost-effective, sustainable practices that increase
                      productivity. high-quality food for consumers, improving
                      public health.
                    </p>{" "}
                  </span>
                </div>
              </li>
              <li >
                <div className="list-item">
                  <span className="elementor-icon-list-icon">
                    <svg
                      aria-hidden="true"
                      className="e-font-icon-svg e-fas-leaf"
                      viewBox="0 0 576 512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
                    </svg>{" "}
                  </span>
                  <span className="elementor-icon-list-text">
                    <b>Environmental Benefits</b>
                    <br />
                    <p style={{ fontWeight: "lighter" }}>
                      IndG.A.P promotes eco-friendly practices, reducing carbon
                      footprints and supporting the UN SDGs.
                    </p>{" "}
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div> */}
			</div>
			<Footer />
		</>
	);
};

export default Agripreneurs;
